module.exports = __webpack_public_path__ + "static/media/ic-isometric-pull.f735738b.svg";